(function () {
  'use strict';
  var durationMs = 175 * 60 * 1000;
  // Preserve Drain Cleaner's original saved clock and synchronize all product pages.
  var storageKey = 'upeDrainCycleStart:DS107791:v1';
  var fallbackStart = Date.UTC(2026, 9, 9, 0, 0, 0);
  function two(n) { return String(n).padStart(2, '0'); }
  function setup(banner) {
    if (!banner || banner.dataset.upeSharedReady === '1') return;
    banner.dataset.upeSharedReady = '1';
    var clock = banner.querySelector('[data-upe-shared-countdown]');
    var price = banner.querySelector('[data-upe-offer-price]');
    if (!clock) return;
    var startedAt = Date.now();
    try {
      var saved = Number(window.localStorage.getItem(storageKey));
      if (Number.isFinite(saved) && saved > 0 && saved <= startedAt) {
        startedAt = saved;
      } else {
        window.localStorage.setItem(storageKey, String(startedAt));
      }
    } catch (error) { startedAt = fallbackStart; }
    function tick() {
      if (!banner.isConnected) { window.clearInterval(interval); return; }
      var elapsed = Math.max(0, Date.now() - startedAt);
      var remainingSeconds = Math.ceil((durationMs - (elapsed % durationMs)) / 1000);
      // The offer clock repeats after each full 175-minute cycle, never stopping at zero.
      if (!Number.isFinite(remainingSeconds) || remainingSeconds < 1) remainingSeconds = Math.floor(durationMs / 1000);
      clock.textContent = two(Math.floor(remainingSeconds / 3600)) + ':' +
        two(Math.floor((remainingSeconds % 3600) / 60)) + ':' + two(remainingSeconds % 60);
    }
    var variants = [];
    try { variants = JSON.parse(banner.querySelector('[data-upe-timer-variants]').textContent || '[]'); } catch (error) {}
    function syncPrice() {
      if (!price || !variants.length) return;
      var custom = document.querySelector('[data-mp-variant-select]');
      var nativeForm = document.querySelector('[id^="product-form-"] input[name="id"]');
      var selected = custom ? custom.value : nativeForm ? nativeForm.value : null;
      var variant = variants.find(function (v) { return String(v.id) === String(selected); });
      if (variant && variant.price) price.textContent = variant.price;
    }
    tick();
    var interval = window.setInterval(tick, 1000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(); });
    window.addEventListener('pageshow', tick);
    window.addEventListener('focus', tick);
    document.addEventListener('change', function (ev) {
      if (ev.target.matches('[data-mp-variant-select], variant-selects select, variant-radios input, input[name="id"]')) {
        window.setTimeout(syncPrice, 80);
        window.setTimeout(syncPrice, 250);
      }
    });
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        if (variant && price) {
          var found = variants.find(function (v) { return String(v.id) === String(variant.id); });
          if (found && found.price) price.textContent = found.price;
        }
      });
    }
    syncPrice();
  }
  function initialize() {
    document.querySelectorAll('[data-upe-shared-offer]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
